import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AirspaceRiskSidebarComponent } from '../view/airspace-risk-sidebar/airspace-risk-sidebar.component';
import { AirspaceRiskViewComponent } from '../view/airspace-risk-view/airspace-risk-view.component';
@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                component: AirspaceRiskViewComponent,
                children: []
            },
            {
                path: '',
                component: AirspaceRiskSidebarComponent,
                outlet: 'sidebar'
            }
        ])
    ],
    exports: [RouterModule]
})
export class AirspaceRiskRoutingModule {}
